import { translate as resolve } from "@tree-company/discussit-embed";
import NL_TRANSLATIONS from "./nl.json";

export const LANGUAGE = "nl";

export const TRANSLATIONS = NL_TRANSLATIONS;

export function translate(key, interpolations) {
  return resolve(TRANSLATIONS, key, interpolations);
}
